<template>
    <transition name="el-fade-in-linear" style="position: relative">
        <div v-show="showMain" class="transition-box">
            <div id="formblock">
                <SearchBar ref="searchRef" msg="C100" @search="onLoadTable" />
            </div>
            <div id="datablock" style="height: calc(100vh - 352px)">
                <el-row type="flex" justify="end">
                    <el-button type="primary" round plain @click="onAddClick" v-show="store.getters.check_auth('ADD')">新增</el-button>
                    <el-button type="primary" round plain @click="onExportClick" v-show="store.getters.check_auth('PRINT')">下載明細</el-button>
                </el-row>

                <div ref="table" style="margin-top:10px;"></div>

            </div>

            <!-- 新增/匯款紀錄 -->
            <Remittance ref="remitRef" msg="/RemittanceRecord" :VENDORID="VENDORID" @reload="onLoadTable"></Remittance>

        </div>
    </transition>
</template>

<script setup>
    import { ref, reactive, onBeforeMount, onMounted, nextTick } from 'vue';
    import { createPopper } from '@popperjs/core';
    import { TabulatorFull as Tabulator } from 'tabulator-tables'; //import Tabulator library
    import { ElMessage, ElMessageBox, ElLoading } from 'element-plus'
    import { useDownload } from '@/composables/download'
    import SearchBar from '@/components/SearchBar.vue'
    import Remittance from '@/components/Remittance.vue'
    import $api from '@/utils/axios';
    import { useStore } from "vuex";
    const store = useStore();

    const showMain = ref(true);//顯示主頁面
    const dialogTitle = ref('');//dialog標題
    const dialogFormVisible = ref(false);//顯示dialog
    const IDdisabled = ref(false);//編輯時ID狀態
    const addOrEdit = ref('');
    const formData = ref(null);
    const searchRef = ref(null); //搜尋列
    const remitRef = ref(null);  //[新增/匯款紀錄]

    const table = ref(null); //reference to your table element
    const tabulator = ref(null); //variable to hold your table

    const onLoadTable = (data) => {
        if (data == null) data = searchRef.value.searchForm;
        $api.GET('/api/OutletPay/GetTableData', {
            CUST_CODE: data.CUST_CODE, BRAND_NAME: data.BRAND_NAME, VENDOR_ID: data.VENDOR_ID, START_DATE: data.START_DATE, END_DATE: data.END_DATE
        }).then((response) => {
            tabulator.value.setData(response);
        });

        store.dispatch('getBalAmt');
    }

    const onExportClick = () => {
        let data = searchRef.value.searchForm;
        $api.POST('/api/OutletPay/ExportExcel', {
            param: searchRef.value.searchForm
        }).then((response) => {
            useDownload('/api/Home/DownloadFile?URL_ADDR=' + response, response.split('\\')[1]);
        });
    }

    const VENDORID = ref('');
    const onAddClick = () => {
        var searchForm = searchRef.value.searchForm;
        if (searchForm.CUST_CODE == "") {
            ElMessageBox.alert('請指定餐飲平台', '提示', {
                confirmButtonText: '確定', type: 'warning'
            });
        } else if (searchForm.BRAND_NAME == "") {
            ElMessageBox.alert('請指定品牌', '提示', {
                confirmButtonText: '確定', type: 'warning'
            });
        } else if (searchForm.VENDOR_ID == "" || searchForm.VENDOR_ID == 'ALL') {
            ElMessageBox.alert('請指定門店', '提示', {
                confirmButtonText: '確定', type: 'warning'
            });
        } else {
            VENDORID.value = searchForm.VENDOR_ID;
            remitRef.value.onAddClick();
        }
    }

    const onDetailClick = (e, cell) => {
        formData.value = JSON.parse(JSON.stringify(cell.getData()));
        formData.value.TRADE_DATE = new Date(formData.value.TRADE_TIME).toLocaleString([], { year: "numeric", month: "2-digit", day: "2-digit" });
        formData.value.TRADE_TIME = new Date(formData.value.TRADE_TIME).toLocaleString([], { hour12: false, hour: "2-digit", minute: "2-digit", second: "2-digit" });
        formData.value.CREATE_TIME = new Date(formData.value.CREATE_TIME).toLocaleString([], { year: "numeric", month: "2-digit", day: "2-digit", hour12: false, hour: "2-digit", minute: "2-digit", second: "2-digit" });

        remitRef.value.onEditClick(formData.value);
    }

    const onDeleteClick = (e, cell) => {
        ElMessageBox.confirm('確定要刪除?', '提示', {
            confirmButtonText: '確認',
            cancelButtonText: '取消',
            type: 'warning',
        }).then(() => {
            $api.POST('/api/OutletPay/Delete', {
                form: cell.getData(), URL_ADDR: "/RemittanceRecord"
            }).then((res) => {
                ElMessageBox.alert('刪除成功!', '提示', {
                    confirmButtonText: '確定',
                    callback: action => {
                        onLoadTable(searchRef.value.searchForm);
                    }
                });
            }).catch((error) => {
                ElMessageBox.alert('刪除失敗!', '提示', {
                    confirmButtonText: '確定'
                });
            });
        });
    }

    const DetailIcon = (cell, formatterParams, onRendered) => {
        var container = document.createElement('button');
        container.setAttribute('id', 'PAY_' + cell.getRow().getData().PAY_SEQ);
        container.setAttribute('class', 'el-button');
        container.setAttribute('type', 'button');
        container.setAttribute('v-popover', 'popoverRef');
        container.setAttribute('aria-disabled', 'false');
        container.setAttribute('style', 'font-size: 20px; padding: 5px;');
        var icon = '<i class="el-icon"><svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" data-v-ea893728=""><path fill="currentColor" d="M831.872 340.864 512 652.672 192.128 340.864a30.592 30.592 0 0 0-42.752 0 29.12 29.12 0 0 0 0 41.6L489.664 714.24a32 32 0 0 0 44.672 0l340.288-331.712a29.12 29.12 0 0 0 0-41.728 30.592 30.592 0 0 0-42.752 0z"></path></svg></i>';
        container.innerHTML = icon;

        return container;
    };

    const deleteIcon = (cell, formatterParams) => {
        return '<i class="el-icon"><svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M352 192V95.936a32 32 0 0 1 32-32h256a32 32 0 0 1 32 32V192h256a32 32 0 1 1 0 64H96a32 32 0 0 1 0-64h256zm64 0h192v-64H416v64zM192 960a32 32 0 0 1-32-32V256h704v672a32 32 0 0 1-32 32H192zm224-192a32 32 0 0 0 32-32V416a32 32 0 0 0-64 0v320a32 32 0 0 0 32 32zm192 0a32 32 0 0 0 32-32V416a32 32 0 0 0-64 0v320a32 32 0 0 0 32 32z"></path></svg></i>';
    }

    onMounted(() => {
        //instantiate Tabulator when element is mounted
        tabulator.value = new Tabulator(table.value, {
            locale: "zh-tw",
            layout: "fitColumns",      //fit columns to width of table
            maxHeight: "calc(100vh - 392px)", //do not let table get bigger than the height of its parent element
            columnHeaderVertAlign: "middle", //align header contents to middle of cell
            headerVisible: true,
            pagination: true,       //paginate the data
            paginationSize: 50,         //allow 50 rows per page of data
            paginationSizeSelector: [50, 100, 200],
            paginationMode: "remote", //enable remote pagination
            sortMode: "remote", //send sort data to the server instead of processing locally
            reactiveData: true, //enable data reactivity
            columns: [
                { title: "序號", formatter: "rownum", width: 50, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false },
                {
                    title: "交易日期", field: "TRADE_TIME", width: 150, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false,
                    formatter: function (cell, formatterParams) {
                        return new Date(cell.getValue()).toLocaleString([], { year: "numeric", month: "2-digit", day: "2-digit", hour12: false, hour: "2-digit", minute: "2-digit", second: "2-digit" });
                    }
                },
                { title: "付款方式", field: "PAY_TYPE", width: 150, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false },
                {
                    title: "交易金額", field: "PAY_AMT", width: 150, headerHozAlign: "center", hozAlign: "right", vertAlign: "middle", headerSort: false,
                    formatter: function (cell, formatterParams) {
                        let pay = cell.getRow().getData().PAY_AMT.replace(/\B(?=(\d{3})+(?!\d))/g, ',').split('.')[0];
                        return cell.getRow().getData().CURR + ' ' + pay;
                    }
                },
                { title: "交易識別碼", field: "TRADE_NO", width: 150, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false },
                { title: "備註說明", field: "REMARKS", headerHozAlign: "center", hozAlign: "left", vertAlign: "middle", headerSort: false },
                { title: "", field: "detail", formatter: DetailIcon, width: 50, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false, cellClick: onDetailClick },
                { title: "刪除", field: "delete", formatter: deleteIcon, width: 50, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false, cellClick: onDeleteClick }
            ],
            langs: {
                "zh-tw": {
                    "pagination": {
                        "page_size": "選擇筆數",
                        "first": "第一頁",
                        "last": "最後一頁",
                        "prev": "上一頁",
                        "next": "下一頁",
                    }
                }
            },
        });
        tabulator.value.on("tableBuilt", function () {
            if (!store.getters.check_auth('DEL')) {
                tabulator.value.hideColumn('delete');
            }
        });
    });

</script>

<style>
    #remit_popover .el-scrollbar__bar.is-horizontal {
        display: none;
    }
</style>
